{
    "welcome-to": "Bienvenido a",
    "copyright": "Copyright",
    "trademarks": "Todas las marcas comerciales o marcas registradas son propiedad de sus respectivos propietarios.",

    "menu-profile": "Perfil",
    "menu-logout": "Cerrar sesión",
    "menu-home": "Inicio",
    "menu-dashboard": "Tablero",
    "menu-machines": "Máquinas",
    "menu-colaboration": "Colaboración",
    "menu-administration": "Administración",
    "menu-machine": "Máquina",
    "menu-list": "Lista",
    "menu-service-data": "Datos de servicio",
    "menu-trash": "Papelera",

    "machine-info": "Información de la máquina",
    "medium": "Medio",
    "machine-activity": "Actividad de la máquina",
    "machine-part-info": "Información de la parte de la máquina",
    "name": "Nombre",
    "version": "Versión",
    "owner": "Propietario",
    "state": "Estado",
    "actions": "Acciones",
    "kind": "Tipo",
    "description": "Descripción",
    "size": "Tamaño",
    "last-write": "Última modificación",
    "ver": "Ver.",
    "restore": "Restaurar",
    "when": "Cuándo",
    "type": "Tipo",
    "level": "Nivel",
    "text": "Texto",
    "tags": "Etiquetas",
    "part-type": "Tipo de parte",
    "firmware-version": "Versión del firmware",
    "model": "Modelo",
    "created": "Creado",
    "modified": "Modificado",
    "status": "Estado",
    "loading": "Cargando",
    "fv": "V.f.",
    "remove": "Eliminar",
    "user": "Usuario",
    "fenix-version": "Versión Fenix",
    "service-data-remove-question": "¿Estás seguro de que deseas eliminar estos datos de servicio?",
    "save-as-duplicate": "Guardar como duplicado",
    "upload-file": "Subir archivo",
    "restore-machine-data-from-backup": "Restaurar datos de la máquina desde la copia de seguridad",
    "you-want-to-change-owner": "¿Quieres cambiar el propietario?",
    "choose-file": "Seleccionar archivo",
    "detail": "Detalle",
    "yes": "Sí",
    "no": "No",
    "machine-detail-remove-question": "¿Estás seguro de que deseas eliminar esta máquina?",
    "status-auto-update": "Actualización automática del estado",
    "download": "Descargar",
    "copy": "Copiar",
    "move": "Mover",
    "change-owner": "Cambiar propietario",
    "new-machine-name": "Nuevo nombre de la máquina",
    "submit": "Enviar",
    "set-as-current": "Establecer como actual",
    "checkout": "Pago",
    "base-data": "Datos base",
    "part-structure-type": "Tipo de estructura de la parte",
    "owner-id": "ID del propietario",
    "parent-id": "ID principal",
    "part-class-type": "Tipo de clase de parte",
    "errors": "Errores",
    "generic-device": "Dispositivo genérico",
    "device-model": "Modelo del dispositivo",
    "address": "Dirección",
    "camera-info": "Información de la cámara",
    "sensor-model": "Modelo del sensor",
    "slides-in-view": "Diapositivas en vista",
    "slider-info": "Información del deslizador",
    "channels": "Canales",
    "shot-stats-from": "Estadísticas de disparos desde",
    "shot-stats-to": "Estadísticas de disparos hasta",
    "shot-stats-counter": "Contador de estadísticas de disparos",
    "shot-stats": "Estadísticas de disparos",
    "slider": "Deslizador",
    "valve": "Válvula",
    "number-shots": "Número de disparos",
    "custom": "Personalizado",
    "move-machine": "Mover máquina",
    "machine-is-not-selected": "Máquina no seleccionada.",
    "machine-successfully-deleted": "Máquina eliminada con éxito.",
    "failed-to-delete-machine": "Error al eliminar la máquina.",
    "failed-to-backup-machine": "Error al realizar la copia de seguridad de la máquina.",
    "owner-successfully-changed": "Propietario cambiado con éxito.",
    "failed-to-change-owner": "Error al cambiar el propietario.",
    "machine-successfully-copied": "Máquina copiada con éxito.",
    "failed-to-copy-machine": "Error al copiar la máquina.",
    "machine-successfully-moved": "Máquina movida con éxito.",
    "failed-to-move-machine": "Error al mover la máquina.",
    "machine-set-as-current": "Máquina establecida como actual.",
    "install-app-question": "¿Te gustaría instalar la aplicación 3U Vision Cloud?",
    "install": "Instalar",
    "cancel": "Cancelar",
    "install-application": "Instalar aplicación",
    "step": "Paso",
    "tap-share-icon": "Toca el ícono de compartir.",
    "scroll-down-and-tap": "En el menú de compartir, desplázate hacia abajo y toca",
    "add-to-home-screen": "Añadir a la pantalla de inicio",
    "you-will-be-propted": "Se te pedirá que nombres la aplicación. Puedes mantener el nombre predeterminado o cambiarlo según desees. Luego, toca",
    "add": "Añadir",
    "in-top-right-corner": "en la esquina superior derecha",
    "do-not-show-again": "No mostrar de nuevo",
    "you-are-offline": "Estás desconectado.",
    "app-can-not-work-offline": "La aplicación no puede funcionar sin conexión.",
    "please-check-your-internet-connection": "Por favor, verifica tu conexión a Internet.",
    "unexpected-server-version": "Versión del servidor inesperada.",
    "current-is": "La actual es",
    "and-expected": "y se esperaba",
    "application-version-is": "La versión de la aplicación es",
    "new-version-available": "Nueva versión disponible",
    "do-you-want-to-install": "¿Quieres instalarla?",
    "delete-confirmation": "Confirmación de eliminación",
    "machine-medium-remove-question": "¿Estás seguro de que deseas eliminar el medio?",
    "machine-medium-checkout-error": "Error al hacer checkout del medio de la máquina.",
    "invalid-data": "Datos inválidos.",
    "failed-to-load-messages": "Error al cargar los mensajes.",
    "failed-to-save-board": "Error al guardar el tablero.",
    "failed-to-delete-board": "Error al eliminar el tablero.",
    "machine-structure-caption": "Strukturo",
    "machine-structure-value-caption": "Valoro",
    "machine-structure-not-available" : "Maŝina strukturo ne haveblas",
    "machines-upload-file-upload-in-progress": "Carga de archivo en progreso.",
    "upload-success": "Carga exitosa."
  }
